import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EditBookingComponent } from './edit-booking.component';
import { BookingsResolve } from '../bookings.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manage/admin/bookings/edit/:id',
        component: EditBookingComponent,
        resolve: {
          bookings: BookingsResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class EditBookingRoutingModule {}
